import { JSX, MouseEvent } from 'react';
import { Dayjs } from 'dayjs';
import { mapGroupSchedule } from 'entities/groups';
import { mapScheduleDateData } from 'entities/schedulePublic/lib';
import { mapTeacherSchedule } from 'entities/teachers';
import {
  IGroupSchedule,
  IMappedGroupSchedule,
  IMappedScheduleDateData,
  IMappedTeacherSchedule,
  ITeacherSchedule,
} from 'entities/types';

import { CardSchedule, EmptyCardSchedule } from '../../cardSchedule/ui';

import { getWeeksDates } from './getWeeksDates';

export const makeCards = (
  isGroupSchedule: boolean,
  data: IGroupSchedule[] | ITeacherSchedule[],
  startDate: Dayjs,
  onClick: (
    event: MouseEvent,
    dataSchedule: IMappedGroupSchedule[] | IMappedTeacherSchedule[],
    dateData: IMappedScheduleDateData,
  ) => void,
) => {
  const res: JSX.Element[] = [];

  const { firstWeekMonday, lastWeekSunday } = getWeeksDates(startDate);

  const mappedData = isGroupSchedule
    ? mapGroupSchedule(
        firstWeekMonday,
        lastWeekSunday.add(-1, 'day'),
        data as IGroupSchedule[],
      )
    : mapTeacherSchedule(
        firstWeekMonday,
        lastWeekSunday.add(-1, 'day'),
        data as ITeacherSchedule[],
      );
  if (mappedData.length === lastWeekSunday.diff(firstWeekMonday, 'day')) {
    const dataDateArray = mapScheduleDateData(
      firstWeekMonday,
      lastWeekSunday,
      mappedData,
    );
    mappedData.forEach((item, index) => {
      const dateKey =
        dataDateArray[index].dateDayjs.format('YYYY-MM-DD') + index.toString();
      if (item.length !== 0) {
        res.push(
          <CardSchedule
            isGroupSchedule={isGroupSchedule}
            dataDate={dataDateArray[index]}
            isWeekend={dataDateArray[index].dateDayjs.day() === 0}
            onClick={onClick}
            isNotThisMonth={
              dataDateArray[index].dateDayjs.month() !== startDate.month()
            }
            dataSchedule={item}
            key={item[0] ? item[0].key : index}
          />,
        );
      } else {
        res.push(
          <EmptyCardSchedule
            dataDate={dataDateArray[index]}
            isWeekend={dataDateArray[index].dateDayjs.day() === 0}
            isNotThisMonth={
              dataDateArray[index].dateDayjs.month() !== startDate.month()
            }
            key={dateKey}
          />,
        );
      }
    });
  }

  return res;
};
